import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { FeedWrapper, StyledDivider, StyledFeed } from '../style'
import { useFormContext } from 'react-hook-form'
import InfoPopup from '~/components/InfoPopup'
import { Message } from 'semantic-ui-react'
import LinkPopup from '../../LinkPopup'
import { CO2OptionsType } from '~/api/services/co2'

interface Props {
  feed: any
  isOpenFeedModal: boolean
  handleClose: (submited?: boolean) => void
  milkOptions: CO2OptionsType
  index: number
}

const RearingPhaseAssign: React.FC<Props> = (props) => {
  const { setValue, getValues } = useFormContext()
  const { feed, isOpenFeedModal, handleClose, milkOptions, index } = props
  const { t } = useTranslation()

  const [feeds, setFeeds] = useState({
    coarseFeeds: [],
    concentratedFeeds: []
  })

  useEffect(() => {
    if (isOpenFeedModal) {
      setFeeds({
        coarseFeeds: feed['coarseFeeds'],
        concentratedFeeds: feed['concentratedFeeds']
      })
    }
  }, [isOpenFeedModal, index, feed])

  const feedOptionsCalves = [
    {
      title: t('Coarse Feeds'),
      key: 'youngCattleCoarseFeeds'
    },
    {
      title: t('Power and mineral feed'),
      key: 'youngCattleConcentratedFeeds'
    }
  ]

  function handleClickFeed(key, feedOption) {
    const index = feeds[key].findIndex(field => field['id'] === feedOption.id)
    if (index >= 0) {
      setFeeds({
        ...feeds,
        [key]: feeds[key].filter(feed => feed.id !== feedOption.id)
      })
      return
    }
    setFeeds({
      ...feeds,
      [key]: [...feeds[key], { ...feedOption, value: '' }]
    })
  }

  function renderConcentratedFeeds(feedOptions, title, paneKey) {
    return <FeedWrapper style={{ marginLeft: 20 }}>
      <div style={{ width: 'fit-content' }}>
        <div className='feed-title'>{title}</div>
        <StyledDivider />
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {feedOptions.map(feedOption => {
          const active = feeds.concentratedFeeds.find(field => field['id'] === feedOption.id)
          return <div style={{ display: 'flex', alignItems: 'center', gap: 3 }} key={`concentratedFeeds-${feedOption.id}`}>
            <StyledFeed
              key={`${paneKey}-${feedOption.id}`}
              onClick={() => handleClickFeed('concentratedFeeds', feedOption)}
              className={active ? 'active-feed' : ''}
              basic>{feedOption.label}
            </StyledFeed>
            {feedOption.id === 15 && feedOption.group === 2 && <div style={{ display: 'flex', gap: 5 }}>
              <InfoPopup
                content={'Wählen Sie dieses Feld aus, falls sie nachweislich in der EU produziertes Soja bezogen haben, oder das Soja selbst hergestellt haben.'}
                styleIcon={{ fontSize: '1.3em' }}
                position={'top center'}
              />
              <LinkPopup
                content={'Ein hoher Sojaschroteinsatz aus Übersee hat einen negativen Einfluss auf den CO2-Fußabdruck. '}
              />
            </div>}
          </div>
        })}
      </div>
    </FeedWrapper>
  }

  function getFeedKey(paneKey: string) {
    if (paneKey === 'youngCattleCoarseFeeds') {
      return 'coarseFeeds'
    }
    else if (paneKey === 'youngCattleConcentratedFeeds') {
      return 'concentratedFeeds'
    }
    return paneKey
  }

  function renderFeedElements(paneOption) {
    const { key, title } = paneOption
    const feedOptions = milkOptions[key]
    return <FeedWrapper>
      <div className='title'>
        <div style={{ display: 'flex', gap: 5 }}>
          <div>{title}</div>
          {paneOption?.info && <InfoPopup
            content={paneOption?.info}
            styleIcon={{ fontSize: '1.3em' }}
            position={'top center'}
          />}
        </div>
      </div>
      <StyledDivider />
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {feedOptions.map(feedOption => {
          const feedkey = getFeedKey(key)
          const active = feeds[feedkey]?.find(field => field['id'] === feedOption.id)

          return <StyledFeed
            key={`${feedkey}-${feedOption.id}`}
            onClick={() => handleClickFeed(feedkey, feedOption)}
            className={active ? 'active-feed' : ''}
            basic>{feedOption.label}</StyledFeed>
        })}
      </div>
    </FeedWrapper>
  }

  function renderFeeds() {
    return <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
      <Message info style={{ borderRadius: 10, marginLeft: 'auto', marginRight: 'auto', marginTop: 0 }}>
        <div>{t('The fields for your required feed appear colored after selection.')}</div>
      </Message>
      {feedOptionsCalves.map(paneOption => {
        if (!['cowsConcentratedFeeds', 'youngCattleConcentratedFeeds'].includes(paneOption.key)) {
          return renderFeedElements(paneOption)
        }
        return <FeedWrapper key={paneOption.key}>
          <div className='title'>{paneOption.title}</div>
          <StyledDivider />
          {Object.keys(milkOptions[paneOption.key]).map((key) => {
            return renderConcentratedFeeds(milkOptions[paneOption.key][key], key, paneOption.key)
          })}
        </FeedWrapper>
      })}
    </div>
  }

  function getNumberOfFeeds() {
    let sum = 0
    Object.keys(feeds).map(key => {
      sum += Object.values(feeds[key]).length
    })
    return sum
  }

  return <Dialog
    textHeader={t('Assignment of feed to the feed group {{name}}', { name: feed?.name || '' })}
    isDialogOpen={isOpenFeedModal}
    textSubmit={t('Assign feeds')}
    textClose={t('Cancel')}
    textContent={renderFeeds()}
    handleClose={() => handleClose()}
    disableSubmit={getNumberOfFeeds() === 0}
    handleSubmit={() => {
      const rearingPhaseValues = getValues('rearingPhases')
      const idElement = rearingPhaseValues[index]['name']
      const element = document.getElementById(idElement)
      if (element.classList.contains('error-feed-group')) {
        element.classList.remove('error-feed-group')
      }
      setValue(`rearingPhases[${index}]`, {
        ...rearingPhaseValues[index],
        ...feeds
      })
      handleClose(true)
    }}
  />
}
export default RearingPhaseAssign